import { LeaderLine } from '../leaderLine';
import { createOptions } from './createOptions';

const GRAVITY = 120;

const CORNERS = {
  topLeft: { point: { x: 0, y: 0 }, gravity: [-GRAVITY, -GRAVITY] },
  topRight: { point: { x: '100%', y: 0 }, gravity: [GRAVITY, -GRAVITY] },
  bottomLeft: { point: { x: 0, y: '100%' }, gravity: [-GRAVITY, GRAVITY] },
  bottomRight: { point: { x: '100%', y: '100%' }, gravity: [GRAVITY, GRAVITY] },
};

const customPosition = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];
const respectiveEndPosition = ['bottomRight', 'bottomLeft', 'topRight', 'topLeft'];

export const makeAConnection = (from, to, startPosition, endPosition, options = {}) => {
  let start = document.getElementById(from);
  let end = document.getElementById(to);
  if (!endPosition && customPosition.some((position) => position === startPosition)) {
    endPosition = respectiveEndPosition[customPosition.indexOf(startPosition)];
  }
  if (customPosition.some((position) => position === startPosition)) {
    const { point, gravity } = CORNERS[startPosition];
    start = LeaderLine.pointAnchor(start, point);
    options.startSocketGravity = gravity;
  }
  if (customPosition.some((position) => position === endPosition)) {
    const { point, gravity } = CORNERS[endPosition];
    end = LeaderLine.pointAnchor(end, point);
    options.endSocketGravity = gravity;
  }
  options = Object.assign(options, createOptions(startPosition || 'bottom', endPosition));
  if (start && end) {
    const line = new LeaderLine(start, end, options);
    return line;
  }
  return {};
};
